import React from "react";

import { Box, Typography } from "@mui/material";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { renderNumber } from "utils/formatter";

import { XPBarSlider } from "../Item";

interface IProps {
  currentXP: number;
  maxXP: number;
  onClick: () => void;
  maxWidth?: string;
}

const Progress: React.FC<IProps> = ({ currentXP, maxXP, onClick, maxWidth = "250px" }) => {
  const { colors } = useMUIThemeModeContext();
  const isDone = currentXP >= maxXP;

  const getProgressPercentage = () => {
    if (maxXP === 0) return 0;
    return Math.round((100 * currentXP) / maxXP);
  };

  return (
    <Box
      px={2}
      pt={1}
      pb={1.5}
      borderRadius={2}
      width={"100%"}
      maxWidth={maxWidth}
      sx={{ cursor: "pointer" }}
      bgcolor={colors.white}
      onClick={onClick}>
      <XPBarSlider min={0} max={100} value={getProgressPercentage()} success={isDone} />
      <Typography fontFamily={"Nunito"} fontWeight={fontWeight.extraBold} color={isDone ? colors["success"] : "primary.main"} fontSize={"1rem"}>
        {`${renderNumber(currentXP)} / ${renderNumber(maxXP)} XP`}
      </Typography>
    </Box>
  );
};

export default Progress;
